import { connect } from "react-redux";
import UpdateCategoryComponent from "./update_category";
import React from "react";
import { withRouter } from "react-router-dom";
import { updateCategory } from "../../../actions/virtual_staging_actions";
import { closeModal } from "../../../actions/modal_actions";
import {showToast} from "../../../actions/toast_actions";

const msp = (state, ownProps) => ({
  errors: Array.isArray(state.errors?.session) ? state.errors?.session : [],
  currentUser: state.entities.users[state.session.currentUser.id]
});

const mdp = (dispatch) => ({
  updateCategory: (category_data, category_id) => dispatch(updateCategory(category_data, category_id)),
  closeModal: () => { dispatch(closeModal()) },
  showToast: (message) => dispatch(showToast(message))
});

export default withRouter(connect(msp, mdp)(UpdateCategoryComponent));